import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import { currencies } from "@/i18n/index.js";


/**
 * Renvoi l'alignement horizontal à utilisé pour l'export avec table-to-excel
 * @param {*} numFormat le type de nm-format
 * @param {*} siteCurrency la currency actuelle du site
 * @returns right si c'est une valeur monétaire. Sinon center
 */
export function getExportHorizontalAlignement(numFormat, siteCurrency) {
  const priceNumFormat = '#,##0.00 "' + (currencies[siteCurrency] || '€') + '"';
  if (numFormat == priceNumFormat) {
    return "right";
  }
  return "center";
}

/**
 * Renvoi le type de nm-format à utilisé pour l'export avec table-to-excel
 * @param {*} value La valeur du champs
 * @param {*} key  Le code du champs
 * @returns Un nm-format viable si la valeur est un nomber, null sinon
 */
export function getExportNumFormat(value = "", key = "", displayZero = false, siteCurrency) {
  if (value === true || value === false) return null;
  var s = null;
  key = key
    .split("##")
    .find(
      (x) =>
        Object.values(dimensionEnum).includes(x) ||
        Object.values(mesureEnum).includes(x) ||
        Object.values(calculatedColumnsEnum).includes(x) ||
        Object.values(alternativeColumnLabelEnum).includes(x)
    );
  if ((!displayZero && !value) || isNaN(value)) return s;
  try {
    switch (key) {
      case dimensionEnum.OMNIPLAYEVENT_REFERENCE:
      case dimensionEnum.OMNIPLAYEVENT_INVOICENUMBER:
      case mesureEnum.PURGEHISTORY_TOKEN_PRICE:
        return s;
      case mesureEnum.PURCHASEHISTORY_AMOUNT:
      case mesureEnum.PURCHASEHISTORY_AMOUNTCB:
      case mesureEnum.PURCHASEHISTORY_AMOUNTCASH:
      case mesureEnum.GAMEHISTORY_TOKEN_PRICE:
      case mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT:
      case alternativeColumnLabelEnum.GAMEHISTORY_TOKEN_PRICE:
      case alternativeColumnLabelEnum.GAMEHISTORY_TOKEN_PRICE_HT:
      case mesureEnum.GAMEHISTORY_TOTAL_VAT:
      case mesureEnum.SNACKHISTORY_TOKEN_PRICE:
      case mesureEnum.SNACKHISTORY_TOKEN_PRICE_HT:
      case mesureEnum.SNACKHISTORY_TOTAL_VAT:
      case mesureEnum.STAFFGAMEHISTORY_REVENUE_EQUIVALENT_TTC:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_TOTAL:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT2:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_CASH:
      case alternativeColumnLabelEnum.PURCHASEHISTORY_AMOUNT_CB:
      case calculatedColumnsEnum.REVENUE_EQUIVALENT_TTC:
      case calculatedColumnsEnum.REVENUE_EQUIVALENT_HT:
      case calculatedColumnsEnum.REVENUE_TTC:
      case calculatedColumnsEnum.REVENUE_HT:
      case calculatedColumnsEnum.REVENUE_TVA:
      case calculatedColumnsEnum.TOTAL_DATA:
      case calculatedColumnsEnum.TOTAL_DATA_HT:
      case calculatedColumnsEnum.TOTAL_DATA_TTC:
      case calculatedColumnsEnum.NOT_SPENT:
      case calculatedColumnsEnum.TOTAL_DATA_TAXES:
      case calculatedColumnsEnum.INVOICE_AMOUNT_PERIOD1:
      case calculatedColumnsEnum.INVOICE_AMOUNT_PERIOD2:
      case calculatedColumnsEnum.INVOICE_AMOUNT_HT_PERIOD1:
      case calculatedColumnsEnum.INVOICE_AMOUNT_HT_PERIOD2:
      case calculatedColumnsEnum.TOTAL_EURO:
      case calculatedColumnsEnum.AVERAGE_BASKET:
      case calculatedColumnsEnum.REVENUE_TTC_LONG:
      case calculatedColumnsEnum.REVENUE_HT_LONG:
      case calculatedColumnsEnum.TTC_DIFFERENCE:
      case calculatedColumnsEnum.TOTAL:
      case calculatedColumnsEnum.DIFF_REVENUE:
      case calculatedColumnsEnum.RUNNINGTOTALS_TTC_DIFFERENCE:
      case mesureEnum.VFULLHOURLYACCOUNTING_EXTRA_REVENUE:
      case mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC:
      case calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT:
      case alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC:
      case alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC2:
      case dimensionEnum.OMNIPLAYEVENT_CREDIT:
      case dimensionEnum.OMNIPLAYEVENT_DEBIT:
      case mesureEnum.AZURECOST_EQUIVALENT_TRANSACTION:
      case mesureEnum.PURGEHISTORY_CA_GENERATED:
      case mesureEnum.OMNIPLAYEVENT_TOTALTTC:
      case mesureEnum.SNACKHISTORY_EQUIVALENT_EURO_WITHOUTCB:
      case calculatedColumnsEnum.TOTAL_REVENUE_5:
      case calculatedColumnsEnum.TOTAL_REVENUE_10:
      case calculatedColumnsEnum.TOTAL_REVENUE_20:
        s = '#,##0.00 "' + (currencies[siteCurrency] || '€') + '"';
        break;
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_SNACK:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_MERCHANDISING:
      case calculatedColumnsEnum.PERCENT_PER_ACTIVITY_GAME:
      case calculatedColumnsEnum.TAXES_PERCENTAGE:
      case calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE:
      case calculatedColumnsEnum.PERCENT_TOTAL_CB:
      case calculatedColumnsEnum.PERCENT_TOTAL_CASH:
      case calculatedColumnsEnum.PERCENT_PER_KIOSK_PERIOD1:
      case calculatedColumnsEnum.PERCENT_PER_KIOSK_PERIOD2:
      case calculatedColumnsEnum.PERCENT_PER_GAME_PERIOD1:
      case calculatedColumnsEnum.PERCENT_PER_GAME_PERIOD2:
      case calculatedColumnsEnum.PERCENT_REVENUE_PER_GAME:
      case calculatedColumnsEnum.PERCENT_TOKENS_PER_GAME:
      case calculatedColumnsEnum.PERCENT_REVENUE_PER_SNACK:
      case calculatedColumnsEnum.PERCENT_TOKEN:
      case calculatedColumnsEnum.COMPARE_INVOICE_AMOUNTS:
      case calculatedColumnsEnum.COMPARE_INVOICE_AMOUNTS_HT:
      case calculatedColumnsEnum.PERCENT_BONUS_TOKEN:
      case calculatedColumnsEnum.BONUS_TOKENS_RATIO:
      case calculatedColumnsEnum.PERCENT_TOKEN_NOT_CONSUMED:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_5:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_10:
      case calculatedColumnsEnum.PERCENT_TOTAL_REVENUE_20:
      case dimensionEnum.GAMEHISTORY_TAXESPERCENT:
      case mesureEnum.AZURECOST_PERCENT_TRANSACTION:
        // eslint-disable-next-line no-useless-escape
        //On utilise les '"' autour du % pour éviter qu'excel ne divise par 100 le chiffre
        s = '#,##0.00"%"';
        break;
      case calculatedColumnsEnum.COMPARE_REVENUE_PERCENT:
      case dimensionEnum.GAME_TOKENPRICEASDIMENSION:
      case dimensionEnum.SMARTTOUCHMAINTENANCE_MAINTENANCEDURATION:
        s = "#,##0";
        break;
      case mesureEnum.VSMARTTOUCHMAINTENANCE_DURATION_SUM:
      default:
        if (
          key && // the key guard prevent errors for the cards report
          (key.startsWith(mesureEnum.VFULLHOURLYACCOUNTING_AMOUNT_HT) ||
            key.startsWith(calculatedColumnsEnum.TOTAL_DYNAMIC_TAXES))
        ) {
          s = '#,##0.00 "' + (currencies[siteCurrency] || '€') + '"';
        } else {
          if (!isNaN(value)) s = "#,##0";
        }
        break;
    }
  } catch (error) {
    console.log(error);
  }
  return s;
}
